<template>
  <div>
    <template v-if="$route.name === 'DocumentTemplateUpdate'">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'DocumentTemplateList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <Form
                    :handle-submit="onSendForm"
                    :values="initialValues"
                    :violations="violations"/>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Update',
  components: {
    Form
  },
  data () {
    return {
      item: {
      }
    }
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(this.id)
  },
  beforeCreate () {
    checkPagePermission('configuration', 'DocumentTemplateList')
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'DocumentTemplateList' })
    },
    retrieved (val) {
      this.item = val
    }
  },
  computed: {
    initialValues () {
      return this.item
    },
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'documenttemplate/update/updated',
      retrieved: 'documenttemplate/show/retrieved',
      violations: 'documenttemplate/update/violations'
    })
  },
  methods: {
    onSendForm () {
      this.update(this.item)
    },
    ...mapActions({
      update: 'documenttemplate/update/update',
      retrieve: 'documenttemplate/show/retrieve',
      reset: 'documenttemplate/update/reset'
    })
  }
}
</script>

<style scoped>

</style>
